import React, { useState, useEffect, useRef } from "react";
import leftArrowSvg from "../../Assets/leftArrowSvg.svg";
import rightArrowSvg from "../../Assets/rightArrowSvg.svg";
import google_Logo from "../../Assets/google_Logo.png";
import fb_Logo from "../../Assets/fb_Logo.png";
import Trivago_Logo from "../../Assets/Trivago_Logo.png";
import zomato_Logo from "../../Assets/zomato_Logo.png";
import brand_logo from "../../Assets/brand_logo.png";
import { SquareUserRound } from "lucide-react";
import Temp1 from "../NewOnboading/Templates/temp1";
import Temp2 from "../NewOnboading/Templates/temp2";
import badimage from "../../../src/Assets/negativeExp.png";
import backImage from "../../../src/Assets/image_13.png";
import backImage2 from "../../../src/Assets/backImg3.png";
import Temp3 from "../NewOnboading/Templates/temp3";
import greatImage from "../../../src/Assets/PositiveExp.png";
import { handleError, handleSuccess } from "../../CommonJquery/CommonJquery.js";

import {
  server_post_data,
  custom_qr_manage,
  save_custom_qr_manage,
} from "../../ServiceConnection/serviceconnection";
import "../CSS/NewOnboading/Step7.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import Loader from "../../pages/Loader.js";

function FeedbackScreen() {
  const [fieldErrors, setFieldErrors] = useState({
    headingText: false,
    subheadingText: false,
    ctaHeading: false,
    ctaText: false,
    ctaHeading1: false,
    ctaText1: false,
    logo: false,
  });
  const [shakeFields, setShakeFields] = useState({
    headingText: false,
    subheadingText: false,
    ctaHeading: false,
    ctaText: false,
    ctaHeading1: false,
    ctaText1: false,
  });

  const [error, setError] = useState(false);
  const [activeTemplateId, setActiveTemplateId] = useState("1");
  const [logo, setLogo] = useState(null);
  const [Logoold, setLogoold] = useState(null);
  const [headingText, setHeadingText] = useState("Your Feedback Matters!");
  const [BusinessText, setBusinessText] = useState("Business Name");
  const [tagLineText, settagLineText] = useState("Tagline");
  const [subheadingText, setSubheadingText] = useState(
    "Enjoyed your experience? Share your reviews on your favorite platform below!",
  );
  const [selectedTemplate, setSelectedTemplate] = useState(1);
  const [ctaHeading, setCtaHeading] = useState("If you had a bad experience!");
  const [ctaHeading1, setCtaHeading1] = useState("Good Experience");
  const [ctaText, setCtaText] = useState("Contact Manager");
  const [ctaText1, setCtaText1] = useState("Needs Improvement");
  const [showModal, setShowModal] = useState(false);
  // Refs for file inputs
  const leftFileInputRef = useRef(null);
  const rightFileInputRef = useRef(null);

  // Handle logo upload
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      setImage(e.target.files[0]);
      reader.onload = (e) => {
        setLogo(e.target.result);
        setFieldErrors((prev) => ({
          ...prev,
          logo: false,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTemplateSelection = (templateId, slideIndex) => {
    setSelectedTemplate(templateId);
    setActiveTemplateId(String(templateId));

    console.log(
      "Selected Template ID:",
      templateId,
      "Slide Index:",
      slideIndex,
    );

    if (swiperRef.current && typeof slideIndex === "number") {
      swiperRef.current.slideTo(slideIndex);
    }
  };
  const handlePreviewMobile = () => {
    setShowModal(!showModal);
  };
  const [image, setImage] = useState([]);
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [businessTypes, setbusinessTypes] = useState([]);
  const [businessImage, setbusinessImage] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [businessTypes2, setbusinessTypes2] = useState([]);
  const [businessImage2, setbusinessImage2] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [styles, setStyles] = useState({
    backgroundColor: "#ec5e3a",
    textColor: "#00000",
    ctaColor: "#ff5722",
  });

  const TEMPLATES = [
    {
      id: "6",
      name: "Template 1",
      component: Temp1,
    },
    {
      id: "2",
      name: "Template 2",
      component: Temp2,
    },
    {
      id: "1",
      name: "Template 3",
      component: Temp3,
    },
  ];

  const isLightColor = ({ r, g, b }) => {
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 200;
  };

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    // fd.append("flag", "6");
    await server_post_data(custom_qr_manage, fd)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          console.log("Hello", final_data);

          setBgColor(final_data.User_Data.application_color);
          console.log(
            "application_color",
            final_data.User_Data.application_color,
          );
          setLogo(final_data.full_logo_url);
          setLogoold(final_data.User_Data.website_logo);
          setbusinessTypes2(final_data.review_linkss_data2);
          setbusinessImage2(final_data.review_linkss_link2);
          setActiveTemplateId(final_data.User_Data.theme_other_id);
          setStyles({
            ...styles,
            backgroundColor: final_data.User_Data.application_color,
            textColor: isLightColor(final_data.User_Data.application_color)
              ? "#000000"
              : "#FFFFFF",
          });
          if (
            final_data.User_Data.heading_text !== "" &&
            final_data.User_Data.heading_text !== null
          ) {
            setHeadingText(final_data.User_Data.heading_text);
          }
          if (
            final_data.User_Data.subheading_text !== "" &&
            final_data.User_Data.subheading_text !== null
          ) {
            setSubheadingText(final_data.onboarding_data[0].subheading_text);
          }
          if (
            final_data.User_Data.cta_heading !== "" &&
            final_data.User_Data.cta_heading !== null
          ) {
            if (final_data.User_Data.theme_other_id !== "6") {
              setCtaHeading1(final_data.User_Data.cta_heading);
            } else {
              setCtaHeading(final_data.User_Data.cta_heading);
            }
          }
          if (
            final_data.User_Data.cta_text !== "" &&
            final_data.User_Data.cta_text !== null
          ) {
            if (final_data.User_Data.theme_other_id !== "6") {
              setCtaText1(final_data.User_Data.cta_text);
              console.log("In CTA Text 1");
            } else {
              setCtaText(final_data.User_Data.cta_text);
              console.log("In CTA Text ");
            }
          }
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
  }, []);

  const handleSave = async () => {
    try {
      setShowLoaderAdmin(true);
      let fd_from = new FormData();
      fd_from.append("flag", "0");
      fd_from.append("old_image", Logoold);
      fd_from.append("application_color", bgColor);
      // fd_from.append("application_text_color", logo);
      fd_from.append("heading_text", headingText);
      fd_from.append("subheading_text", subheadingText);
      fd_from.append("cta_heading", ctaHeading);
      fd_from.append("cta_text", ctaText);
      fd_from.append("theme_other_id", selectedTemplate);
      await server_post_data(save_custom_qr_manage, fd_from)
        .then((Response) => {
          setShowLoaderAdmin(false);
          let data = Response.message.split("~@~");
          const final_data = JSON.parse(data[1]);
          if (parseInt(data[0]) === 1) {
            handleError(final_data.message);
          } else {
            master_data_get();
          }
        })
        .catch((error) => {
          console.log(error);
          setShowLoaderAdmin(false);
        });
      handleSuccess("QR Saved successfully!");
    } catch (error) {
      handleError("Error saving settings. Please try again.");
    }
  };

  const validateContentFields = () => {
    const newErrors = {
      headingText: !headingText.trim(),
      subheadingText: !subheadingText.trim(),
      ctaHeading: activeTemplateId === "6" ? !ctaHeading.trim() : false,
      ctaText: activeTemplateId === "6" ? !ctaText.trim() : false,
      ctaHeading1:
        activeTemplateId === "1" || activeTemplateId === "2"
          ? !ctaHeading1.trim()
          : false,
      ctaText1:
        activeTemplateId === "1" || activeTemplateId === "2"
          ? !ctaText1.trim()
          : false,
      logo: !logo,
    };

    setFieldErrors(newErrors);
    Object.entries(newErrors).forEach(([key, val]) => {
      if (val) {
        setShakeFields((prev) => ({ ...prev, [key]: true }));
        setTimeout(() => {
          setShakeFields((prev) => ({ ...prev, [key]: false }));
        }, 400);
      }
    });

    return !Object.values(newErrors).some((val) => val);
  };

  const renderActiveTemplate = () => {
    // Get the template from our templates object
    const activeTemplate = TEMPLATES.find(
      (template) => template.id === activeTemplateId,
    );

    if (!activeTemplate) {
      console.error(`Template with ID ${activeTemplateId} not found`);
      return null;
    }

    const TemplateComponent = activeTemplate.component;

    let finalCtaHeading = ctaHeading;
    let finalCtatext = ctaText;

    if (activeTemplateId === "2" || activeTemplateId === "1") {
      finalCtaHeading = ctaHeading1;
      finalCtatext = ctaText1;
    } else {
      finalCtaHeading = ctaHeading;
      finalCtatext = ctaText;
    }

    return (
      <TemplateComponent
        logo={logo}
        brand_logo={brand_logo}
        headingText={headingText}
        subheadingText={subheadingText}
        businessTypes2={businessTypes2}
        businessImage2={businessImage2}
        ctaHeading={finalCtaHeading}
        ctaText={finalCtatext}
        styles={styles}
        SquareUserRound={SquareUserRound}
        rightFileInputRef={rightFileInputRef}
      />
    );
  };
  //  carausal Logic
  const carouselRef = useRef(null);
  const [startX, setStartX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [angle, setAngle] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      // setIsMobile(width < 768);
      setIsMobile(width < 991);

      // setIsTablet(width >= 768 && width < 991);
      setIsDesktop(width >= 991);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  // Ensure the active item is centered when activeIndex changes
  useEffect(() => {
    if (activeIndex !== null) {
      const targetAngle = activeIndex * 120;
      setAngle(targetAngle);
    }
  }, [activeIndex]);

  const handleTouchStart = (e) => {
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    setStartX(clientX);
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const deltaX = clientX - startX;

    // Calculate new angle based on drag distance
    // Negative multiplier for natural feeling (drag right = rotate left)
    const newAngle = angle - deltaX * 0.2;
    setAngle(newAngle);

    // Update active index based on angle
    const normalizedAngle = ((newAngle % 360) + 360) % 360;
    let newActiveIndex;

    if (normalizedAngle >= 300 || normalizedAngle < 60) {
      newActiveIndex = 0;
    } else if (normalizedAngle >= 60 && normalizedAngle < 180) {
      newActiveIndex = 1;
    } else {
      newActiveIndex = 2;
    }

    if (newActiveIndex !== activeIndex) {
      setActiveIndex(newActiveIndex);
    }

    setStartX(clientX);
  };

  const handleTouchEnd = () => {
    if (!isDragging) return;

    setIsDragging(false);

    // Snap to closest item
    const targetAngle = activeIndex * 120;
    setAngle(targetAngle);
  };

  const handleSelect = (index) => {
    setActiveIndex(index);
    setAngle(index * 120);
  };

  const swiperRef = useRef(null);
  return (
    <>
      {ShowLoaderAdmin && <Loader />}
      <div className="tell_aboutSection step7Container">
        <div className="bussiness_typeCard" style={{ position: "relative" }}>
          <div className="step7Div">
            <div className="row ">
              <div className="col-lg-8">
                <div className="customizer-panel">
                  <div className="d-flex gap-2 align-items-center h3HeadScanPage"></div>
                  <div className="form-group">
                    <label>Select a Template</label>
                    <div className="qr_manage_height_clss2">
                      {isDesktop && (
                        <>
                          <div className="newcutmTemplate">
                            <div
                              className={`template-card ${
                                selectedTemplate === 6
                                  ? "selected-template"
                                  : ""
                              }`}
                              style={{
                                backgroundImage: `url(${backImage2})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100%",
                              }}
                              onClick={() => handleTemplateSelection(6)}
                            >
                              <div className="underTemplateContent">
                                <div className="text-center mb-4">
                                  <div className="wow-logo1 justify-content-center d-inline-flex">
                                    <img
                                      src={logo || brand_logo}
                                      alt="Brand Logo"
                                      className="preview-logo"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = brand_logo;
                                      }}
                                    />
                                  </div>
                                </div>

                                <h2 className="temp1Headtxt">{headingText}</h2>
                                <p className="temp1Subheading">
                                  {subheadingText}
                                </p>

                                <div className="temp1bottmData">
                                  <img
                                    src={google_Logo || "/placeholder.svg"}
                                    alt="google"
                                    title="google"
                                  />
                                  <img
                                    src={fb_Logo || "/placeholder.svg"}
                                    alt="Facebook"
                                    title="Facebook"
                                  />
                                  <img
                                    src={Trivago_Logo || "/placeholder.svg"}
                                    alt="Trivago"
                                    title="Trivago"
                                  />
                                  <img
                                    src={zomato_Logo || "/placeholder.svg"}
                                    alt="Zomato"
                                    title="Zomato"
                                  />
                                </div>
                                <p className="template1bottmHeading">
                                  {ctaHeading}
                                </p>
                              </div>
                              <button
                                className="ctbtntemplate"
                                style={{
                                  backgroundColor: `url(${bgColor})`,
                                }}
                                type="button"
                              >
                                <SquareUserRound className="cta_icnn" />
                                Contact Manager
                              </button>
                            </div>

                            <div
                              className={`template-card ${
                                selectedTemplate === 2
                                  ? "selected-template"
                                  : ""
                              }`}
                              style={{
                                backgroundImage: `url(${backImage})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100%",
                              }}
                              onClick={() => handleTemplateSelection(2)}
                            >
                              <div
                                className="logo-preview mx-auto"
                                style={{
                                  marginTop: "10px",
                                  border: "1px solid #777",
                                  padding: "20px 40px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "60px",
                                  width: "70px",
                                }}
                              >
                                <input
                                  type="file"
                                  ref={rightFileInputRef}
                                  accept="image/*"
                                  style={{ display: "none", cursor: "pointer" }}
                                  readOnly
                                />
                                {logo ? (
                                  <img
                                    src={logo || brand_logo}
                                    alt="Brand Logo"
                                    className="preview-logo"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = brand_logo;
                                    }}
                                    style={{
                                      maxWidth: "60px",
                                      maxHeight: "50px",
                                    }}
                                  />
                                ) : (
                                  <div
                                    className="logo-placeholder"
                                    style={{
                                      color: "#777",
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      letterSpacing: "1px",
                                    }}
                                  >
                                    PLACE LOGO
                                  </div>
                                )}
                              </div>

                              <div
                                className="preview-heading"
                                style={{
                                  marginTop: "0px",
                                  textAlign: "center",
                                  fontSize: "16px",
                                  fontWeight: 600,
                                }}
                              >
                                {headingText}
                              </div>
                              <div
                                className="preview-subheading"
                                style={{
                                  fontSize: "10px",
                                  color: "#555",
                                  maxWidth: "250px",
                                  textAlign: "center",
                                  margin: "0px auto",
                                }}
                              >
                                {subheadingText}
                              </div>

                              <div
                                className="social-icons"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px",
                                  marginTop: "30px",
                                  width: "100%",
                                  maxWidth: "250px",
                                  margin: "30px auto 0",
                                }}
                              >
                                <button
                                  className="rating-button positive"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 12px",
                                    borderRadius: "30px",
                                    border: "none",
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    backgroundColor: "rgb(240 255 240)",
                                    color: "#333",
                                  }}
                                >
                                  <img
                                    src={greatImage || "/placeholder.svg"}
                                    alt="Great Experience"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      marginRight: "10px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                    }}
                                  >
                                    Good Experience
                                  </span>
                                </button>

                                <button
                                  className="rating-button negative"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 12px",
                                    borderRadius: "30px",
                                    border: "none",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    backgroundColor: "rgb(255 240 240)",
                                    color: "#333",
                                  }}
                                >
                                  <img
                                    src={badimage || "/placeholder.svg"}
                                    alt="Needs Improvement"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      marginRight: "10px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "14px",
                                    }}
                                  >
                                    Needs Improvement
                                  </span>
                                </button>
                              </div>
                            </div>
                            {/* New Template  */}
                            <div
                              className={`template-card ${
                                selectedTemplate === 2
                                  ? "selected-template"
                                  : ""
                              }`}
                              style={{
                                position: "relative",
                                backgroundImage: `url(${"https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE4fHx8ZW58MHx8fHx8"})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "space-around",
                                padding: "20px 10px",
                                color: "white",
                                overflow: "hidden",
                              }}
                              onClick={() => handleTemplateSelection(2)}
                            >
                              {/* Black Overlay */}
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  backgroundColor: "rgba(0,0,0,0.6)", // black overlay
                                  zIndex: 1,
                                }}
                              ></div>

                              {/* Content */}
                              <div
                                style={{
                                  position: "relative",
                                  zIndex: 2,
                                  width: "100%",
                                }}
                              >
                                {/* Logo */}
                                <div
                                  className="logo-preview mx-auto"
                                  style={{
                                    marginTop: "10px",
                                    border: "1px solid #777",
                                    padding: "10px 20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60px",
                                    width: "60px",
                                    background: "#ffffff",
                                    borderRadius: "12px",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                  }}
                                >
                                  {logo ? (
                                    <img
                                      src={logo || brand_logo}
                                      alt="Brand Logo"
                                      className="preview-logo"
                                      style={{
                                        maxWidth: "50px",
                                        maxHeight: "40px",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="logo-placeholder"
                                      style={{
                                        color: "#777",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      PLACE LOGO
                                    </div>
                                  )}
                                </div>

                                {/* Headings */}
                                <p
                                  className="preview-heading"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    margin: "8px 0",
                                    textShadow: "1px 1px 2px rgba(0,0,0,0.6)",
                                    color: "#fff",
                                  }}
                                >
                                  {headingText || "Your Feedback Matters!"}
                                </p>

                                <p
                                  className="preview-subheading"
                                  style={{
                                    fontSize: "10px",
                                    fontWeight: 400,
                                    textAlign: "center",
                                    marginBottom: "10px",
                                    color: "#ddd",
                                    maxWidth: "250px",
                                    margin: "0 auto",
                                  }}
                                >
                                  {subheadingText ||
                                    "Enjoyed your experience? Share your reviews on your favorite platform below!"}
                                </p>

                                {/* Static Buttons (no slider, just pill buttons) */}
                                <div
                                  className="social-icons"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px",
                                    marginTop: "20px",
                                    width: "100%",
                                    maxWidth: "250px",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                  }}
                                >
                                  {[
                                    {
                                      name: "Google",
                                      logo: google_Logo,
                                    },
                                    {
                                      name: "Facebook",
                                      logo: fb_Logo,
                                    },
                                  ].map((link, idx) => (
                                    <div
                                      key={idx}
                                      style={{
                                        background: "rgba(255,255,255,0.3)",
                                        backdropFilter: "blur(2px)",
                                        borderRadius: "30px",
                                        padding: "8px 15px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        cursor: "default",
                                        height: "40px",
                                        width: "180px",
                                      }}
                                    >
                                      {/* Logo */}
                                      <div
                                        style={{
                                          width: "26px",
                                          height: "26px",
                                          borderRadius: "50%",
                                          overflow: "hidden",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          background: "#fff",
                                        }}
                                      >
                                        <img
                                          src={link.logo}
                                          alt={link.name}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </div>
                                      {/* Name */}
                                      <span
                                        style={{
                                          color: "#fff",
                                          fontSize: "13px",
                                          fontWeight: 500,
                                          padding: 0,
                                        }}
                                      >
                                        {link.name}
                                      </span>
                                    </div>
                                  ))}
                                </div>

                                {/* CTA */}
                                <div
                                  className="cta-container"
                                  style={{
                                    marginTop: "20px",
                                    textAlign: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      marginBottom: "8px",
                                      textShadow: "1px 1px 2px rgba(0,0,0,0.4)",
                                      color: "#fff",
                                    }}
                                  >
                                    {ctaHeading ||
                                      "If you had a bad experience!"}
                                  </p>
                                  <div
                                    className="manager-button"
                                    style={{
                                      background: "#fcba1c",
                                      borderRadius: "30px",
                                      padding: "8px 15px",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      color: "#3d1010",
                                      cursor: "pointer",
                                      display: "inline-block",
                                    }}
                                  >
                                    {ctaText || "Contact Manager"}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`template-card ${
                                selectedTemplate === 3
                                  ? "selected-template"
                                  : ""
                              }`}
                              style={{
                                position: "relative",
                                backgroundImage: `url(${"https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE4fHx8ZW58MHx8fHx8"})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "space-around",
                                padding: "20px 10px",
                                color: "white",
                                overflow: "hidden",
                              }}
                              onClick={() => handleTemplateSelection(3)}
                            >
                              {/* Black Overlay */}
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  backgroundColor: "rgba(0,0,0,0.6)",
                                  zIndex: 1,
                                }}
                              ></div>

                              {/* Content */}
                              <div
                                style={{
                                  position: "relative",
                                  zIndex: 2,
                                  width: "100%",
                                }}
                              >
                                {/* Logo */}
                                <div
                                  className="logo-preview mx-auto"
                                  style={{
                                    marginTop: "10px",
                                    padding: "10px 20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60px",
                                    width: "60px",
                                    background: "#ffffff",
                                    borderRadius: "12px",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                  }}
                                >
                                  {logo ? (
                                    <img
                                      src={logo || brand_logo}
                                      alt="Brand Logo"
                                      className="preview-logo"
                                      style={{
                                        maxWidth: "60px",
                                        maxHeight: "50px",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="logo-placeholder"
                                      style={{
                                        color: "#777",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      PLACE LOGO
                                    </div>
                                  )}
                                </div>

                                {/* Headings */}
                                <p
                                  className="preview-heading"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    margin: 0,
                                    textShadow: "1px 1px 2px rgba(0,0,0,0.6)",
                                    color: "#fff",
                                  }}
                                >
                                  {"Dear Guest"}
                                </p>
                                <p
                                  className="preview-heading"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    margin: "0 0 8px 0",
                                    textShadow: "1px 1px 2px rgba(0,0,0,0.6)",
                                    color: "#fff",
                                  }}
                                >
                                  {headingText || "Your Feedback Matters!"}
                                </p>

                                <p
                                  className="preview-subheading"
                                  style={{
                                    fontSize: "10px",
                                    fontWeight: 400,
                                    textAlign: "center",
                                    marginBottom: "10px",
                                    color: "#ddd",
                                    maxWidth: "250px",
                                    margin: "0 auto",
                                  }}
                                >
                                  {subheadingText ||
                                    "Enjoyed your experience? Share your reviews on your favorite platform below!"}
                                </p>

                                {/* Feedback Buttons */}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                    marginTop: "20px",
                                    width: "100%",
                                    maxWidth: "280px",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                  }}
                                >
                                  {/* Great Experience */}
                                  <div
                                    style={{
                                      background: "#fff",
                                      borderRadius: "30px",
                                      padding: "10px 10px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      height: "50px",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                          borderRadius: "50%",
                                          background: "#4CAF50",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          color: "#fff",
                                          fontSize: "16px",
                                        }}
                                      >
                                        👍
                                      </div>
                                      <span
                                        style={{
                                          color: "#000",
                                          fontSize: "13px",
                                          fontWeight: 500,
                                          padding: 0,
                                        }}
                                      >
                                        Great Experience
                                      </span>
                                    </div>
                                    <span
                                      style={{
                                        color: "#4CAF50",
                                        fontSize: "16px",
                                        padding: 0,
                                      }}
                                    >
                                      ➔
                                    </span>
                                  </div>

                                  {/* Needs Improvement */}
                                  <div
                                    style={{
                                      background: "#fff",
                                      borderRadius: "30px",
                                      padding: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      height: "50px",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                          borderRadius: "50%",
                                          background: "#f44336",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          color: "#fff",
                                          fontSize: "16px",
                                        }}
                                      >
                                        👎
                                      </div>
                                      <span
                                        style={{
                                          color: "#000",
                                          fontSize: "13px",
                                          fontWeight: 500,
                                          padding: 0,
                                        }}
                                      >
                                        Needs Improvement
                                      </span>
                                    </div>
                                    <span
                                      style={{
                                        color: "#f44336",
                                        fontSize: "16px",
                                        padding: 0,
                                      }}
                                    >
                                      ➔
                                    </span>
                                  </div>
                                </div>

                                {/* Bottom Text */}
                                <p
                                  style={{
                                    marginTop: "20px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: "#fff",
                                  }}
                                >
                                  {ctaHeading || "We Love Your Feedback"}
                                </p>
                              </div>
                            </div>

                            {/* New Template 2 */}

                            <div
                              className={`template-card ${
                                selectedTemplate === 1
                                  ? "selected-template"
                                  : ""
                              }`}
                              onClick={() => handleTemplateSelection(1)}
                            >
                              <div
                                className="logo-preview mx-auto"
                                style={{
                                  marginTop: "10px",
                                  border: "1px solid #777",
                                  padding: "20px 40px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "60px",
                                  width: "70px",
                                }}
                              >
                                <input
                                  type="file"
                                  ref={rightFileInputRef}
                                  accept="image/*"
                                  style={{ display: "none", cursor: "pointer" }}
                                  readOnly
                                />
                                {logo ? (
                                  <img
                                    src={logo || brand_logo}
                                    alt="Brand Logo"
                                    className="preview-logo"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = brand_logo;
                                    }}
                                    style={{
                                      maxWidth: "60px",
                                      maxHeight: "50px",
                                    }}
                                  />
                                ) : (
                                  <div
                                    className="logo-placeholder"
                                    style={{
                                      color: "#777",
                                      fontSize: "24px",
                                      fontWeight: 500,
                                      letterSpacing: "1px",
                                    }}
                                  >
                                    PLACE LOGO
                                  </div>
                                )}
                              </div>

                              <div
                                className="preview-heading"
                                style={{
                                  marginTop: "0px",
                                  textAlign: "center",
                                  fontSize: "16px",
                                  fontWeight: 600,
                                }}
                              >
                                {headingText}
                              </div>
                              <div
                                className="preview-subheading"
                                style={{
                                  fontSize: "10px",
                                  color: "#555",
                                  maxWidth: "250px",
                                  textAlign: "center",
                                  margin: "0px auto",
                                }}
                              >
                                {subheadingText}
                              </div>

                              <div
                                className="social-icons"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px",
                                  marginTop: "30px",
                                  width: "100%",
                                  maxWidth: "250px",
                                  margin: "30px auto 0",
                                }}
                              >
                                <button
                                  className="rating-button positive"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 12px",
                                    borderRadius: "30px",
                                    border: "none",
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    backgroundColor: "rgb(240 255 240)",
                                    color: "#333",
                                  }}
                                >
                                  <img
                                    src={greatImage || "/placeholder.svg"}
                                    alt="Great Experience"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      marginRight: "10px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                    }}
                                  >
                                    Good Experience
                                  </span>
                                </button>

                                <button
                                  className="rating-button negative"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 12px",
                                    borderRadius: "30px",
                                    border: "none",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    backgroundColor: "rgb(255 240 240)",
                                    color: "#333",
                                  }}
                                >
                                  <img
                                    src={badimage || "/placeholder.svg"}
                                    alt="Needs Improvement"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      marginRight: "10px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "14px",
                                    }}
                                  >
                                    Needs Improvement
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {isMobile && (
                        <div className="swiper-container">
                          <Swiper
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            centeredSlides={true}
                            centeredSlidesBounds={true}
                            spaceBetween={20}
                            pagination={{ clickable: true }}
                            navigation={true}
                            autoplay={false}
                            modules={[Pagination, Navigation]}
                            className="template-swiper"
                            style={{ padding: "0 5%" }}
                            breakpoints={{
                              0: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                              },
                              500: {
                                slidesPerView: 1.5,
                                spaceBetween: 10,
                              },
                              768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                              },
                              992: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                              },
                            }}
                          >
                            <SwiperSlide
                              onClick={() => handleTemplateSelection(6, 0)}
                            >
                              <div
                                className={`template-card ${
                                  selectedTemplate === 6
                                    ? "selected-template"
                                    : ""
                                }`}
                                style={{
                                  backgroundImage: `url(${backImage2})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "100%",
                                }}
                              >
                                <div className="underTemplateContent">
                                  <div className="text-center mb-4">
                                    <div className="wow-logo1 justify-content-center d-inline-flex">
                                      <img
                                        src={logo || brand_logo}
                                        alt="Brand Logo"
                                        className="preview-logo"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = brand_logo;
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <h2 className="temp1Headtxt">
                                    {headingText}
                                  </h2>
                                  <p className="temp1Subheading">
                                    {subheadingText}
                                  </p>

                                  <div className="temp1bottmData">
                                    <img
                                      src={google_Logo || "/placeholder.svg"}
                                      alt="google"
                                      title="google"
                                    />
                                    <img
                                      src={fb_Logo || "/placeholder.svg"}
                                      alt="Facebook"
                                      title="Facebook"
                                    />
                                    <img
                                      src={Trivago_Logo || "/placeholder.svg"}
                                      alt="Trivago"
                                      title="Trivago"
                                    />
                                    <img
                                      src={zomato_Logo || "/placeholder.svg"}
                                      alt="Zomato"
                                      title="Zomato"
                                    />
                                  </div>
                                  <p className="template1bottmHeading">
                                    {ctaHeading}
                                  </p>
                                </div>
                                <button
                                  className="ctbtntemplate"
                                  style={{
                                    backgroundColor: `${bgColor}`,
                                  }}
                                  type="button"
                                >
                                  <SquareUserRound className="cta_icnn" />
                                  Contact Manager
                                </button>
                              </div>
                            </SwiperSlide>
                            <SwiperSlide
                              onClick={() => handleTemplateSelection(2, 1)}
                            >
                              <div
                                className={`template-card ${
                                  selectedTemplate === 2
                                    ? "selected-template"
                                    : ""
                                }`}
                                style={{
                                  backgroundImage: `url(${backImage})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "100%",
                                }}
                              >
                                <div
                                  className="logo-preview mx-auto"
                                  style={{
                                    marginTop: "10px",
                                    border: "1px solid #777",
                                    padding: "20px 40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60px",
                                    width: "70px",
                                  }}
                                >
                                  <input
                                    type="file"
                                    ref={rightFileInputRef}
                                    accept="image/*"
                                    style={{
                                      display: "none",
                                      cursor: "pointer",
                                    }}
                                    readOnly
                                  />
                                  {logo ? (
                                    <img
                                      src={logo || brand_logo}
                                      alt="Brand Logo"
                                      className="preview-logo"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = brand_logo;
                                      }}
                                      style={{
                                        maxWidth: "60px",
                                        maxHeight: "50px",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="logo-placeholder"
                                      style={{
                                        color: "#777",
                                        fontSize: "24px",
                                        fontWeight: 500,
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      PLACE LOGO
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="preview-heading"
                                  style={{
                                    marginTop: "0px",
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {headingText}
                                </div>
                                <div
                                  className="preview-subheading"
                                  style={{
                                    fontSize: "10px",
                                    color: "#555",
                                    maxWidth: "250px",
                                    textAlign: "center",
                                    margin: "0px auto",
                                  }}
                                >
                                  {subheadingText}
                                </div>

                                <div
                                  className="social-icons"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                    marginTop: "30px",
                                    width: "100%",
                                    maxWidth: "250px",
                                    margin: "30px auto 0",
                                  }}
                                >
                                  <button
                                    className="rating-button positive"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 12px",
                                      borderRadius: "30px",
                                      border: "none",
                                      fontSize: "13px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      backgroundColor: "rgb(240 255 240)",
                                      color: "#333",
                                    }}
                                  >
                                    <img
                                      src={greatImage || "/placeholder.svg"}
                                      alt="Great Experience"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span style={{ fontSize: "12px" }}>
                                      Good Experience
                                    </span>
                                  </button>

                                  <button
                                    className="rating-button negative"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 12px",
                                      borderRadius: "30px",
                                      border: "none",
                                      fontSize: "16px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      backgroundColor: "rgb(255 240 240)",
                                      color: "#333",
                                    }}
                                  >
                                    <img
                                      src={badimage || "/placeholder.svg"}
                                      alt="Needs Improvement"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        lineHeight: "14px",
                                      }}
                                    >
                                      Needs Improvement
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </SwiperSlide>
                            <SwiperSlide
                              onClick={() => handleTemplateSelection(1, 2)}
                            >
                              <div
                                className={`template-card ${
                                  selectedTemplate === 1
                                    ? "selected-template"
                                    : ""
                                }`}
                              >
                                <div
                                  className="logo-preview mx-auto"
                                  style={{
                                    marginTop: "10px",
                                    border: "1px solid #777",
                                    padding: "20px 40px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60px",
                                    width: "70px",
                                  }}
                                >
                                  <input
                                    type="file"
                                    ref={rightFileInputRef}
                                    accept="image/*"
                                    style={{
                                      display: "none",
                                      cursor: "pointer",
                                    }}
                                    readOnly
                                  />
                                  {logo ? (
                                    <img
                                      src={logo || brand_logo}
                                      alt="Brand Logo"
                                      className="preview-logo"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = brand_logo;
                                      }}
                                      style={{
                                        maxWidth: "60px",
                                        maxHeight: "50px",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="logo-placeholder"
                                      style={{
                                        color: "#777",
                                        fontSize: "24px",
                                        fontWeight: 500,
                                        letterSpacing: "1px",
                                      }}
                                    >
                                      PLACE LOGO
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="preview-heading"
                                  style={{
                                    marginTop: "0px",
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {headingText}
                                </div>
                                <div
                                  className="preview-subheading"
                                  style={{
                                    fontSize: "10px",
                                    color: "#555",
                                    maxWidth: "250px",
                                    textAlign: "center",
                                    margin: "0px auto",
                                  }}
                                >
                                  {subheadingText}
                                </div>

                                <div
                                  className="social-icons"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                    marginTop: "30px",
                                    width: "100%",
                                    maxWidth: "250px",
                                    margin: "30px auto 0",
                                  }}
                                >
                                  <button
                                    className="rating-button positive"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 12px",
                                      borderRadius: "30px",
                                      border: "none",
                                      fontSize: "13px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      backgroundColor: "rgb(240 255 240)",
                                      color: "#333",
                                    }}
                                  >
                                    <img
                                      src={greatImage || "/placeholder.svg"}
                                      alt="Great Experience"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "12px",
                                      }}
                                    >
                                      Good Experience
                                    </span>
                                  </button>

                                  <button
                                    className="rating-button negative"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "8px 12px",
                                      borderRadius: "30px",
                                      border: "none",
                                      fontSize: "16px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                      backgroundColor: "rgb(255 240 240)",
                                      color: "#333",
                                    }}
                                  >
                                    <img
                                      src={badimage || "/placeholder.svg"}
                                      alt="Needs Improvement"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        lineHeight: "14px",
                                      }}
                                    >
                                      Needs Improvement
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </SwiperSlide>

                            {/* New Template Mobile */}
                            <SwiperSlide>
                              <div
                                className={`template-card ${
                                  selectedTemplate === 2
                                    ? "selected-template"
                                    : ""
                                }`}
                                style={{
                                  position: "relative",
                                  backgroundImage: `url(${"https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE4fHx8ZW58MHx8fHx8"})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "space-around",
                                  padding: "20px 10px",
                                  color: "white",
                                  overflow: "hidden",
                                }}
                                onClick={() => handleTemplateSelection(2)}
                              >
                                {/* Black Overlay */}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0,0,0,0.6)", // black overlay
                                    zIndex: 1,
                                  }}
                                ></div>

                                {/* Content */}
                                <div
                                  style={{
                                    position: "relative",
                                    zIndex: 2,
                                    width: "100%",
                                  }}
                                >
                                  {/* Logo */}
                                  <div
                                    className="logo-preview mx-auto"
                                    style={{
                                      marginTop: "10px",
                                      border: "1px solid #777",
                                      padding: "10px 20px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "50px",
                                      width: "50px",
                                      background: "#ffffff",
                                      borderRadius: "12px",
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                    }}
                                  >
                                    {logo ? (
                                      <img
                                        src={logo || brand_logo}
                                        alt="Brand Logo"
                                        className="preview-logo"
                                        style={{
                                          maxWidth: "40px",
                                          maxHeight: "40px",
                                        }}
                                      />
                                    ) : (
                                      <div
                                        className="logo-placeholder"
                                        style={{
                                          color: "#777",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          letterSpacing: "1px",
                                        }}
                                      >
                                        PLACE LOGO
                                      </div>
                                    )}
                                  </div>

                                  {/* Headings */}
                                  <p
                                    className="preview-heading"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      margin: "8px 0",
                                      textShadow: "1px 1px 2px rgba(0,0,0,0.6)",
                                      color: "#fff",
                                    }}
                                  >
                                    {headingText || "Your Feedback Matters!"}
                                  </p>

                                  <p
                                    className="preview-subheading"
                                    style={{
                                      fontSize: "10px",
                                      fontWeight: 400,
                                      textAlign: "center",
                                      marginBottom: "10px",
                                      color: "#ddd",
                                      maxWidth: "250px",
                                      margin: "0 auto",
                                    }}
                                  >
                                    {subheadingText ||
                                      "Enjoyed your experience? Share your reviews on your favorite platform below!"}
                                  </p>

                                  {/* Static Buttons (no slider, just pill buttons) */}
                                  <div
                                    className="social-icons"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                      marginTop: "10px",
                                      width: "100%",
                                      maxWidth: "250px",
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                    }}
                                  >
                                    {[
                                      {
                                        name: "Google",
                                        logo: google_Logo,
                                      },
                                      {
                                        name: "Facebook",
                                        logo: fb_Logo,
                                      },
                                    ].map((link, idx) => (
                                      <div
                                        key={idx}
                                        style={{
                                          background: "rgba(255,255,255,0.3)",
                                          backdropFilter: "blur(2px)",
                                          borderRadius: "30px",
                                          padding: "8px 15px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          cursor: "default",
                                          height: "40px",
                                          width: "180px",
                                        }}
                                      >
                                        {/* Logo */}
                                        <div
                                          style={{
                                            width: "26px",
                                            height: "26px",
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            background: "#fff",
                                          }}
                                        >
                                          <img
                                            src={link.logo}
                                            alt={link.name}
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                              objectFit: "contain",
                                            }}
                                          />
                                        </div>
                                        {/* Name */}
                                        <span
                                          style={{
                                            color: "#fff",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            padding: 0,
                                          }}
                                        >
                                          {link.name}
                                        </span>
                                      </div>
                                    ))}
                                  </div>

                                  {/* CTA */}
                                  <div
                                    className="cta-container"
                                    style={{
                                      marginTop: "0px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        textShadow:
                                          "1px 1px 2px rgba(0,0,0,0.4)",
                                        color: "#fff",
                                      }}
                                    >
                                      {ctaHeading ||
                                        "If you had a bad experience!"}
                                    </p>
                                    <div
                                      className="manager-button"
                                      style={{
                                        background: "#fcba1c",
                                        borderRadius: "30px",
                                        padding: "8px 15px",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        color: "#3d1010",
                                        cursor: "pointer",
                                        display: "inline-block",
                                      }}
                                    >
                                      {ctaText || "Contact Manager"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>

                            <SwiperSlide>
                              <div
                                className={`template-card ${
                                  selectedTemplate === 3
                                    ? "selected-template"
                                    : ""
                                }`}
                                style={{
                                  position: "relative",
                                  backgroundImage: `url(${"https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE4fHx8ZW58MHx8fHx8"})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "space-around",
                                  padding: "20px 10px",
                                  color: "white",
                                  overflow: "hidden",
                                }}
                                onClick={() => handleTemplateSelection(3)}
                              >
                                {/* Black Overlay */}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0,0,0,0.6)",
                                    zIndex: 1,
                                  }}
                                ></div>

                                {/* Content */}
                                <div
                                  style={{
                                    position: "relative",
                                    zIndex: 2,
                                    width: "100%",
                                  }}
                                >
                                  {/* Logo */}
                                  <div
                                    className="logo-preview mx-auto"
                                    style={{
                                      marginTop: "10px",
                                      padding: "10px 20px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "50px",
                                      width: "50px",
                                      background: "#ffffff",
                                      borderRadius: "12px",
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                    }}
                                  >
                                    {logo ? (
                                      <img
                                        src={logo || brand_logo}
                                        alt="Brand Logo"
                                        className="preview-logo"
                                        style={{
                                          maxWidth: "40px",
                                          maxHeight: "40px",
                                        }}
                                      />
                                    ) : (
                                      <div
                                        className="logo-placeholder"
                                        style={{
                                          color: "#777",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          letterSpacing: "1px",
                                        }}
                                      >
                                        PLACE LOGO
                                      </div>
                                    )}
                                  </div>

                                  {/* Headings */}
                                  <p
                                    className="preview-heading"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      margin: 0,
                                      textShadow: "1px 1px 2px rgba(0,0,0,0.6)",
                                      color: "#fff",
                                    }}
                                  >
                                    {"Dear Guest"}
                                  </p>
                                  <p
                                    className="preview-heading"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      margin: "0 0 0 0",
                                      textShadow: "1px 1px 2px rgba(0,0,0,0.6)",
                                      color: "#fff",
                                    }}
                                  >
                                    {headingText || "Your Feedback Matters!"}
                                  </p>

                                  <p
                                    className="preview-subheading"
                                    style={{
                                      fontSize: "10px",
                                      fontWeight: 400,
                                      textAlign: "center",
                                      marginBottom: "10px",
                                      color: "#ddd",
                                      maxWidth: "250px",
                                      margin: "0 auto",
                                    }}
                                  >
                                    {subheadingText ||
                                      "Enjoyed your experience? Share your reviews on your favorite platform below!"}
                                  </p>

                                  {/* Feedback Buttons */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "15px",
                                      marginTop: "10px",
                                      width: "100%",
                                      maxWidth: "280px",
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                    }}
                                  >
                                    {/* Great Experience */}
                                    <div
                                      style={{
                                        background: "#fff",
                                        borderRadius: "30px",
                                        padding: "10px 10px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        height: "45px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            background: "#4CAF50",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "#fff",
                                            fontSize: "16px",
                                          }}
                                        >
                                          👍
                                        </div>
                                        <span
                                          style={{
                                            color: "#000",
                                            fontSize: "10px",
                                            fontWeight: 500,
                                            padding: 0,
                                          }}
                                        >
                                          Great Experience
                                        </span>
                                      </div>
                                      <span
                                        style={{
                                          color: "#4CAF50",
                                          fontSize: "16px",
                                          padding: 0,
                                        }}
                                      >
                                        ➔
                                      </span>
                                    </div>

                                    {/* Needs Improvement */}
                                    <div
                                      style={{
                                        background: "#fff",
                                        borderRadius: "30px",
                                        padding: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        height: "50px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            background: "#f44336",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "#fff",
                                            fontSize: "16px",
                                          }}
                                        >
                                          👎
                                        </div>
                                        <span
                                          style={{
                                            color: "#000",
                                            fontSize: "10px",
                                            fontWeight: 500,
                                            padding: 0,
                                          }}
                                        >
                                          Needs Improvement
                                        </span>
                                      </div>
                                      <span
                                        style={{
                                          color: "#f44336",
                                          fontSize: "16px",
                                          padding: 0,
                                        }}
                                      >
                                        ➔
                                      </span>
                                    </div>
                                  </div>

                                  {/* Bottom Text */}
                                  <p
                                    style={{
                                      marginTop: "20px",
                                      textAlign: "center",
                                      fontSize: "13px",
                                      fontWeight: 600,
                                      color: "#fff",
                                    }}
                                  >
                                    {ctaHeading || "We Love Your Feedback"}
                                  </p>
                                </div>
                              </div>
                            </SwiperSlide>
                          </Swiper>
                        </div>
                      )}

                      {/* Heading Text */}
                      <div className="form-group">
                        <div className="w-100 d-flex justify-content-between align-items-center">
                          <label>Heading Text</label>
                          <div
                            style={{
                              fontSize: "12px",
                              color:
                                headingText.replace(/\s/g, "").length >= 35
                                  ? "red"
                                  : "green",
                            }}
                          >
                            {headingText.replace(/\s/g, "").length} / 35
                          </div>
                        </div>

                        <input
                          type="text"
                          className={`form-control ${
                            fieldErrors.headingText ? "errorRedBorder" : ""
                          } ${shakeFields.headingText ? "shake" : ""}`}
                          value={headingText}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const nonSpaceChars = inputValue.replace(/\s/g, "");
                            if (nonSpaceChars.length <= 35) {
                              setHeadingText(inputValue);
                              if (
                                fieldErrors.headingText &&
                                inputValue.trim()
                              ) {
                                setFieldErrors((prev) => ({
                                  ...prev,
                                  headingText: false,
                                }));
                              }
                            } else {
                              setShakeFields((prev) => ({
                                ...prev,
                                headingText: true,
                              }));
                              setTimeout(
                                () =>
                                  setShakeFields((prev) => ({
                                    ...prev,
                                    headingText: false,
                                  })),
                                400,
                              );
                            }
                          }}
                        />

                        {fieldErrors.headingText && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            Please enter heading text
                          </span>
                        )}
                      </div>

                      {/* Subheading */}
                      <div className="form-group">
                        <div className="w-100 d-flex justify-content-between align-items-center">
                          <label>Subheading</label>
                          <div
                            style={{
                              fontSize: "12px",
                              color:
                                subheadingText.replace(/\s/g, "").length >= 70
                                  ? "red"
                                  : "green",
                            }}
                          >
                            {subheadingText.replace(/\s/g, "").length} / 70
                          </div>
                        </div>

                        <input
                          type="text"
                          className={`form-control ${
                            fieldErrors.subheadingText ? "errorRedBorder" : ""
                          } ${shakeFields.subheadingText ? "shake" : ""}`}
                          value={subheadingText}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            const nonSpaceChars = inputValue.replace(/\s/g, "");
                            if (nonSpaceChars.length <= 70) {
                              setSubheadingText(inputValue);
                              if (
                                fieldErrors.subheadingText &&
                                inputValue.trim()
                              ) {
                                setFieldErrors((prev) => ({
                                  ...prev,
                                  subheadingText: false,
                                }));
                              }
                            } else {
                              setShakeFields((prev) => ({
                                ...prev,
                                subheadingText: true,
                              }));
                              setTimeout(
                                () =>
                                  setShakeFields((prev) => ({
                                    ...prev,
                                    subheadingText: false,
                                  })),
                                400,
                              );
                            }
                          }}
                        />

                        {fieldErrors.subheadingText && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            Please enter subheading
                          </span>
                        )}
                      </div>

                      {/* CTA Heading */}
                      {activeTemplateId === "6" && (
                        <div className="form-group">
                          <div className="w-100 d-flex justify-content-between align-items-center">
                            <label>CTA Heading</label>
                            <div
                              style={{
                                fontSize: "12px",
                                color:
                                  ctaHeading.replace(/\s/g, "").length >= 30
                                    ? "red"
                                    : "green",
                              }}
                            >
                              {ctaHeading.replace(/\s/g, "").length} / 30
                            </div>
                          </div>
                          <input
                            type="text"
                            className={`form-control ${
                              fieldErrors.ctaHeading ? "errorRedBorder" : ""
                            } ${shakeFields.ctaHeading ? "shake" : ""}`}
                            value={ctaHeading}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const nonSpaceChars = inputValue.replace(
                                /\s/g,
                                "",
                              );
                              if (nonSpaceChars.length <= 30) {
                                setCtaHeading(inputValue);
                                if (
                                  fieldErrors.ctaHeading &&
                                  inputValue.trim()
                                ) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    ctaHeading: false,
                                  }));
                                }
                              } else {
                                setShakeFields((prev) => ({
                                  ...prev,
                                  ctaHeading: true,
                                }));
                                setTimeout(
                                  () =>
                                    setShakeFields((prev) => ({
                                      ...prev,
                                      ctaHeading: false,
                                    })),
                                  400,
                                );
                              }
                            }}
                          />

                          {fieldErrors.ctaHeading && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              Please enter CTA heading
                            </span>
                          )}
                        </div>
                      )}

                      {(activeTemplateId === "1" ||
                        activeTemplateId === "2") && (
                        <div className="form-group">
                          <div className="w-100 d-flex justify-content-between align-items-center">
                            <label>Option One</label>
                            <div
                              style={{
                                fontSize: "12px",
                                color:
                                  ctaHeading1.replace(/\s/g, "").length >= 30
                                    ? "red"
                                    : "green",
                              }}
                            >
                              {ctaHeading1.replace(/\s/g, "").length} / 30
                            </div>
                          </div>
                          <input
                            type="text"
                            className={`form-control ${
                              fieldErrors.ctaHeading1 ? "errorRedBorder" : ""
                            } ${shakeFields.ctaHeading1 ? "shake" : ""}`}
                            value={ctaHeading1}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const nonSpaceChars = inputValue.replace(
                                /\s/g,
                                "",
                              );
                              if (nonSpaceChars.length <= 30) {
                                setCtaHeading1(inputValue);
                                setCtaHeading(inputValue);
                                if (
                                  fieldErrors.ctaHeading1 &&
                                  inputValue.trim()
                                ) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    ctaHeading1: false,
                                  }));
                                }
                              } else {
                                setShakeFields((prev) => ({
                                  ...prev,
                                  ctaHeading1: true,
                                }));
                                setTimeout(
                                  () =>
                                    setShakeFields((prev) => ({
                                      ...prev,
                                      ctaHeading1: false,
                                    })),
                                  400,
                                );
                              }
                            }}
                          />

                          {fieldErrors.ctaHeading1 && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              Please enter Option One
                            </span>
                          )}
                        </div>
                      )}

                      {/* CTA Text */}
                      {activeTemplateId === "6" && (
                        <div className="form-group">
                          <div className="w-100 d-flex justify-content-between align-items-center">
                            <label>CTA Text</label>
                            <div
                              style={{
                                fontSize: "12px",
                                color:
                                  ctaText.replace(/\s/g, "").length >= 15
                                    ? "red"
                                    : "green",
                              }}
                            >
                              {ctaText.replace(/\s/g, "").length} / 15
                            </div>
                          </div>
                          <input
                            type="text"
                            className={`form-control ${
                              fieldErrors.ctaText ? "errorRedBorder" : ""
                            } ${shakeFields.ctaText ? "shake" : ""}`}
                            value={ctaText}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const nonSpaceChars = inputValue.replace(
                                /\s/g,
                                "",
                              );
                              if (nonSpaceChars.length <= 15) {
                                setCtaText(inputValue);
                                if (fieldErrors.ctaText && inputValue.trim()) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    ctaText: false,
                                  }));
                                }
                              } else {
                                setShakeFields((prev) => ({
                                  ...prev,
                                  ctaText: true,
                                }));
                                setTimeout(
                                  () =>
                                    setShakeFields((prev) => ({
                                      ...prev,
                                      ctaText: false,
                                    })),
                                  400,
                                );
                              }
                            }}
                          />

                          {fieldErrors.ctaText && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              Please enter CTA text
                            </span>
                          )}
                        </div>
                      )}

                      {(activeTemplateId === "1" ||
                        activeTemplateId === "2") && (
                        <div className="form-group">
                          <div className="w-100 d-flex justify-content-between align-items-center">
                            <label>Option Two</label>
                            <div
                              style={{
                                fontSize: "12px",
                                color:
                                  ctaText1.replace(/\s/g, "").length >= 16
                                    ? "red"
                                    : "green",
                              }}
                            >
                              {ctaText1.replace(/\s/g, "").length} / 16
                            </div>
                          </div>
                          <input
                            type="text"
                            className={`form-control ${
                              fieldErrors.ctaText1 ? "errorRedBorder" : ""
                            } ${shakeFields.ctaText1 ? "shake" : ""}`}
                            value={ctaText1}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const nonSpaceChars = inputValue.replace(
                                /\s/g,
                                "",
                              );
                              if (nonSpaceChars.length <= 16) {
                                setCtaText1(inputValue);
                                setCtaText(inputValue);
                                if (fieldErrors.ctaText1 && inputValue.trim()) {
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    ctaText1: false,
                                  }));
                                }
                              } else {
                                setShakeFields((prev) => ({
                                  ...prev,
                                  ctaText1: true,
                                }));
                                setTimeout(
                                  () =>
                                    setShakeFields((prev) => ({
                                      ...prev,
                                      ctaText1: false,
                                    })),
                                  400,
                                );
                              }
                            }}
                          />

                          {fieldErrors.ctaText1 && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              Please enter Option Two
                            </span>
                          )}
                        </div>
                      )}

                      <div className="actionBTns">
                        <button className="save-button" onClick={handleSave}>
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {renderActiveTemplate()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeedbackScreen;
